export enum EquipmentProblemQuestionValue {
	BrokenLeaningPole = 'Broken or leaning pole',
	PoleTransformerFire = 'Pole or transformer fire',
	ArcingWire = 'Arcing wire',
	StreetlightTrouble = 'Streetlight trouble',
	OutdoorProtectiveLighting = 'Outdoor Protective Lighting (OPL) repair',
}
